import React, { useEffect, useRef, useState } from "react";

export default function CustomCursor() {
  const dot = useRef(null);
  const ring = useRef(null);
  const [supported, setSupported] = useState(false);

  useEffect(() => {
    const isFine = window.matchMedia("(pointer: fine)").matches;
    setSupported(isFine);
    if (!isFine) return;

    let mx = window.innerWidth / 2, my = window.innerHeight / 2;
    let rx = mx, ry = my;

    const move = (e) => {
      mx = e.clientX; my = e.clientY;
      if (dot.current) {
        dot.current.style.transform = `translate(${mx}px, ${my}px) translate(-50%, -50%)`;
      }
    };

    const loop = () => {
      rx += (mx - rx) * 0.18;
      ry += (my - ry) * 0.18;
      if (ring.current) {
        ring.current.style.transform = `translate(${rx}px, ${ry}px) translate(-50%, -50%)`;
      }
      requestAnimationFrame(loop);
    };

    const onOver = (e) => {
      if (!ring.current) return;
      const t = e.target;
      if (t.closest("a,button,[role='button'],input,textarea,select,label,[data-cursor-hover]")) {
        ring.current.classList.add("hover");
      } else {
        ring.current.classList.remove("hover");
      }
    };

    window.addEventListener("mousemove", move);
    window.addEventListener("mouseover", onOver);
    requestAnimationFrame(loop);
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", onOver);
    };
  }, []);

  if (!supported) return null;
  return (
    <>
      <div ref={ring} className="sim-cursor-ring" data-testid="custom-cursor-ring" />
      <div ref={dot} className="sim-cursor-dot" data-testid="custom-cursor-dot" />
    </>
  );
}
